"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.267 15.766c-.732.153-1.49.234-2.267.234-6.075 0-11-4.925-11-11 0-.777.08-1.535.234-2.267A10.003 10.003 0 002 12c0 5.523 4.477 10 10 10 4.19 0 7.779-2.578 9.267-6.234z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;